import React, { useEffect, useRef, useState } from 'react';
import { Button, Icon } from '@pwc/pwc-deals-ui';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import GroupErrorMessage from '../GroupErrorMessage/GroupErrorMessage.tsx';
import './EmptyGroup.scss';

const EmptyGroup = ({
  num,
  createGroupError,
  handleAddGroup,
  handleCancelAddGroup,
  handleChangeGroupName,
  createGroupErrorMessage,
}) => {
  const [value, setValue] = useState('');
  const inputRef = useRef(null);
  const [isAddEnable, setIsAddEnable] = useState(true);
  const { t } = useTranslation();

  const addGroup = async () => {
    setIsAddEnable(false);
    await handleAddGroup(value);
    setIsAddEnable(true);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') addGroup();
  };

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();
  }, []);

  return (
    <div className="empty-group">
      <div className="empty-group__header">
        <div className="empty-group__icon">
          <Icon name="down-chevron" width="24" />
        </div>
        <div className="empty-group-title">
          <div
            className={classNames(
              'empty-group-title__layout',
              createGroupError &&
                value.length > 0 &&
                'empty-group-title__layout--error'
            )}
          >
            <span
              className={classNames(
                'empty-group-title__number',
                value.length > 0 && 'empty-group-title__number--active'
              )}
            >
              {num}.&nbsp;
            </span>
            <input
              ref={inputRef}
              className={classNames(
                'empty-group-title__input',
                value.length > 0 && 'empty-group-title__input--editing'
              )}
              type="text"
              placeholder={t('groupTitle')}
              value={value}
              onChange={(e) => {
                setValue(e.target.value);
                handleChangeGroupName(e.target.value);
              }}
              onKeyDown={handleKeyDown}
            />
            {value.length === 0 && (
              <div className="empty-group-title__edit">
                <Icon
                  width="18"
                  data-testid="edit-icon"
                  name="edit"
                  className="fill icon-grey-alt-lighter"
                />
              </div>
            )}
          </div>
          {createGroupError && value.length > 0 && (
            <div className="empty-group-title__error">
              <GroupErrorMessage message={createGroupErrorMessage} />
            </div>
          )}
          <div className="empty-group-title__count">0 {t('analyses')}</div>
        </div>
      </div>
      <div className="empty-group__controls">
        <Button className="button-menu" onClick={handleCancelAddGroup}>
          {t('groupCancelBtn')}
        </Button>
        <Button
          className="ui-button button-xs"
          disabled={
            value.trim().length === 0 || createGroupError || !isAddEnable
          }
          onClick={addGroup}
        >
          {t('addGroupBtn')}
        </Button>
      </div>
    </div>
  );
};

export default EmptyGroup;
